const noop = (message = '') => message;

export const types = ['text', 'textarea', 'select'];
const requiredError = (required, callback = noop) => {
    const message = typeof required === 'string' ? required : '值不能为空';
    callback(message);
    return message
};
const ruleValidate = (rule, value) => {
    if (rule.required && !value) {
        return true
    }
    if (rule.validator && typeof rule.validator === 'function') {
        return rule.validator(value) === false
    }
    return rule.test && !rule.test.test(value)
};
const rulesValidate = (rules, value) => {
    for (let i = 0; i < rules.length; i++) {
        if (ruleValidate(rules[i], value)) {
            return rules[i].message
        }
    }
    return null
};
/**
 * 对象属性校验
 * @param value
 * @param meta
 * @param required
 * @param rules
 * @param callback
 * @returns {null}
 */
export const propValidator = (value, meta, required, rules, callback = noop) => {
    if (!required || value || value === 0) {
        if (Array.isArray(rules)) {
            const message = rulesValidate(rules, value);
            if (message) {
                callback(message);
                return message
            }
        } else if (typeof rules === 'object' && ruleValidate(rules, value)) {
            callback(rules.message);
            return rules.message
        }
        callback();
        return null
    }
    return requiredError(required, callback)
};
/**
 * 对象多个属性校验
 * @param value
 * @param meta
 * @param required
 * @param rules
 * @param props
 * @param callback
 * @returns {*}
 */
export const propsValidator = (value, meta, required, rules, props, callback = noop) => {
    if (!required || value) {
        let message;
        for (let i = 0; i < props.length; i++) {
            message = propValidator(value[props[i]], meta, required, Array.isArray(rules) ? rules : rules[props[i]]);
            if (message) {
                callback(message);
                return message
            }
        }
        callback();
        return null
    }
    return requiredError(required, callback)
};
/**
 * 通过ref聚焦
 * @param $ref
 */
export const focus = $ref => {
    if ($ref && $ref.$el) {
        const $element = $ref.$el.querySelector('input,textarea');
        $element && $element.focus();
    }
};
